module.exports = __webpack_public_path__ + "img/part-of-logo-icon.c5df9478.svg";